module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=TV - Tuvalu.f8f5a283.svg";